import { Grid } from 'antd'

const { useBreakpoint } = Grid

const useWindowMobile = () => {
  const screens = useBreakpoint()
  const isScreenMobile = (screens.xs || screens.sm) && !screens.md
  return isScreenMobile
}

export default useWindowMobile
